module.exports = __webpack_public_path__ + "img/ico-caret-down.b1a7c6c8.svg";